<template>
  <div>
    <p class="u-mb-4">
      Pour effectuer cette action, connectez-vous ou inscrivez-vous.
    </p>
    <div class="o-row u-ai-c u-jc-sb u-jc-fe@md">
      <div class="o-col u-auto">
        <ButtonSimple
          type="button"
          label="Se connecter"
          outline
          @click="openLoginModal"
        />
      </div>
      <div class="o-col u-auto">
        <ButtonSimple
          route="/inscription"
          label="S'inscrire"
          @click="
            track('cta', {
              cta_name: `Popin connexion : S'inscrire`,
            })
          "
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  openLoginModal: []
}>()

const openLoginModal = () => {
  track('cta', {
    cta_name: 'Popin connexion : Se connecter',
  })
  emit('openLoginModal')
}
</script>
